import { isEmpty } from "lodash";
import { LOCAL_INTEL_URL } from "./const";
import { BRAND } from "@core/brand/brand-config";
import { getSourceAtlasUrl } from "./sourceAtlasUrl";

export function getActualIntelUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const INTEL_URL = !!import.meta.env.VITE_INTEL_URL && import.meta.env.VITE_INTEL_URL !== "" ? import.meta.env.VITE_INTEL_URL : LOCAL_INTEL_URL;
  if (!isEmpty(REACT_ENV)) {
    return INTEL_URL;
  } else {
    return LOCAL_INTEL_URL;
  }
}

export function getIntelUrl() {
  if (BRAND.key === "source_atlas") {
    return getSourceAtlasUrl();
  }
  return getActualIntelUrl();
}

export const getIntelUrlValue = () => {
  return getIntelUrl();
};
